export enum FileDirName {
  Images = 'images',
  File = 'file',
  Video = 'video',
}
